module.exports = __webpack_public_path__ + "static/media/bradesco-saude.52414020.jpg";